export const OMDB_API_KEY = process.env.REACT_APP_OMDB_API_KEY || '';